/**
 * @module $mlsCode
 */
define('$mlsCodeExtend',[],function () {
    return function () {
        $.extend($mlsCode, {
            "M_addReceiver": "수신자를 추가해주세요",
            "M_alreadAddedUser": "이미 목록에 있는 사용자 입니다 [$ID$]",
            "M_alredyAdded": "이미 추가 되었습니다",
            "M_assignApprovalLine": "결재선지정",
            "M_canNotAddMoreThanTenUser": "결재선 설정은 최대 10명까지 가능 합니다",
            "M_cannotPartRejectBySingleStatement": "전표건이 하나인 경우 부분 반려 불가 합니다",
            "M_cardBillCancel": "취소",
            "M_cardBillApprove": "승인",
            "M_dataInitConfirm": "입력하신 자료가 모두 초기화됩니다\n진행하시겠습니까?",
            "M_debitCreditAmountsAreNotEquals": "차변합계 금액과 대변합계 금액이 같지 않습니다",
            "M_deleteConfirm": "삭제 하시겠습니까?",
            "M_chooseApprovalLine": "결재선을 지정해 주세요",
            "M_evidenceDoesNotExist": "첨부된 증빙이 없습니다",
            "M_givenFieldsCannotInput": "$namesString$ 입력 불가 계정 입니다",
            "M_koreanCurrencty": "원화",
            "M_lastApprovalCanNotSetAsAgreementUser": "마지막 결재자는 합의자로 설정 할 수 없습니다",
            "M_modifyOnlyByApprover": "승인권자만 변경 가능 합니다",
            "M_noDataForSelect": "선택할 데이터가 존재하지 않습니다",
            "M_noDataForProcess": "처리할 데이터가 없습니다",
            "M_preserveTenYears": "Confidential / 10년 보존",
            "M_reConsult": "재품의",
            "M_requestApproval": "결재요청",
            "M_selectApprovalLine": "결재선지정",
            "M_selectTarget": "대상을 선택해 주세요",
            "M_sended": "전송되었습니다",
            "M_shouldAddEvidence": "증빙을 추가해 주세요",
            "M_shouldInputAddData": "추가 데이터를 입력하세요",
            "M_shouldInputMoreThanOne": "$namesString$ 중 하나 이상 입력 해 주세요",
            "M_shouldInputNumberOnly": "숫자만 입력 가능합니다",
            "M_shouldInputOnlyOne": "$namesString$ 중 하나만 입력 가능합니다",
            "M_shouldInput": "$elementNameString$ 를 입력해 주세요",
            "M_shouldInput_KunnrLifnrHkont": "$elementNameString$ 중 하나를 입력해 주세요",
            "M_shouldInput_KunnrLifnrHkont_onlyOne": "$elementNameString$ 중 하나만 입력 가능합니다.",
            "M_variableUser": "가변유저",
            "M_viewDraft": "결재문서 조회",
            "M_cannotCreateStatmentWithFinishedDoc": "완료된 건은 전표 생성 하실수 없습니다",
            "M_expenseDistributeCountValidation": "비용 항목이 한건인 경우만 가능 합니다",
            "M_ADD_DATA_INPUT": "입력",
            "M_ADD_DATA_INPUT_NULL": "미입력",
            "M_proceedRequest": "상신 하시겠습니까?",
            "M_cancelRequest": "회수 하시겠습니까?",
            "M_emergencyRequestApproval": "긴급결재",
            "M_draft_0031_grid3Empty": "비용정산 항목을 입력해 주세요",
            "M_draft_0031_gridObjNotSelected": "계획 대비 실적의 출장자를 선택해 주세요",
            "M_UD_0220_122_gridObjNotSelected": "정산 대상 출장자를 선택해 주세요.",
            "M_UD_0220_122_gridObjNotSelected_trans": "전표번호가 존재하는 경우, 교통비 선택은 불가능합니다.",
            "M_DRAFT_0061_deleteEmployee": "비용정산 정보를 삭제 바랍니다. 출장자: ",
            "M_DRAFT_0061_cannotDelete": "생성된 전표가 존재합니다 삭제 바랍니다.",
            "M_DRAFT_1001_newAccountValidation": "계좌 신규 등록시에는\n계좌정보 예금주조회가 필수입니다.",
            "M_DRAFT_1001_accountNameValidation": "예금주가 일치하지 않습니다. \n진행하시겠습니까?",
            "M_DRAFT_1001_deleteAccnameConfirm": "선택한 행의 계약번호가 삭제됩니다. \n진행하시겠습니까?",
            "M_UD_0220_002_cannotCreate": "이미 생성된 전표가 존재합니다.",
            "M_FI_0204_001_adjustmentCannotExceedBalance": "정산금액이 잔액보다 많을 수 없습니다",
            "M_FI_0204_001_adjustment": "정산",
            "M_FI_0204_001_createStatement": "전표생성",
            "M_FI_0204_001_estimatedAmount": "예정금액",
            "M_FI_0204_001_exceed": "초과",
            "M_FI_0204_001_refund": "반환",
            "M_FI_0204_100_isGrid2SelectedChangeFlag": "전표를 선택해 주세요.",
            "M_GRID_customPanelTitle_approver": "결재자",
            "M_GRID_customPanelTitle_reader": "열람자",
            "M_GRID_customPanelTitle_referer": "참조자",
            "M_GRID_customPanelTitle_supporter": "협조자",
            "M_KOSTL_HKONT_Relation_kostlKosarJ": "제조 계정코드를 선택하세요",
            "M_KOSTL_HKONT_Relation_kostlKosarP": "판관 계정코드를 선택하세요",
            "M_MULTIPODATA_DIALOG_EBELNEmptyEBELPNotEmpty": "구매문서 품목번호는 구매전표번호와 같이 검색할 수 있습니다",
            "M_mwskzNonDeduction_changeFormCombo_1": "헤더의 세금코드가 불공제입니다\n계정 확인하세요",
            "M_mwskzNonDeduction_changeFormCombo_2": "헤더의 세금코드가 불공제 입니다\n비용항목 세금코드 확인하세요",
            "M_mwskzNonDeduction_changeFormCombo_3": "헤더의 불공제 세금코드와\n비용항목의 불공제 계정 세금코드가 다릅니다",
            "M_mwskzNonDeduction_changeFormCombo_4": "헤더의 불공제 세금코드와\n비용항목의 불공제 세금코드가 다릅니다",
            "M_mwskzNonDeduction_changeFormCombo_5": "비용항목의 계정 중 불공제가 있습니다 확인하세요",
            "M_mwskzNonDeduction_changeFormCombo_6": "비용항목의 세금코드 중 불공제가 있습니다 확인하세요",
            "M_mwskzNonDeduction_gridChange2_1": "헤더 세금코드가 불공제 입니다\n비용항목 세금코드를 확인하세요",
            "M_mwskzNonDeduction_gridChange2_2": "비용항목 세금코드가 불공제 입니다\n헤더 세금코드를 확인하세요",
            "M_mwskzNonDeduction_gridChange2_3": "불공제 계정 입니다\n비용항목 세금코드를 확인하세요",
            "M_mwskzNonDeduction_gridChange2_4": "비용항목 세금코드가 불공제 입니다\n불공제 계정 선택하세요",
            "M_mwskzNonDeduction_gridChange2_5": "비용항목 불공제 세금코드와\n헤더의 불공제 세금코드가 다릅니다",
            "M_mwskzNonDeduction_gridChange2_6": "비용항목 불공제 세금코드와\n비용항목 계정의 불공제 세금코드가 다릅니다",
            "M_mwskzNonDeduction_gridChange_1": "헤더 세금코드가 불공제 입니다\n불공제 계정 선택하세요",
            "M_mwskzNonDeduction_gridChange_2": "불공제 계정 입니다\n헤더 세금코드 확인하세요",
            "M_mwskzNonDeduction_gridChange_3": "비용항목 세금코드가 불공제 입니다\n불공제 계정 선택하세요",
            "M_mwskzNonDeduction_gridChange_4": "불공제 계정 입니다\n비용항목 세금코드 확인하세요",
            "M_mwskzNonDeduction_gridChange_5": "계정의 불공제 세금코드와 헤더의 불공제 세금코드가 다릅니다",
            "M_mwskzNonDeduction_gridChange_6": "계정의 불공제 세금코드와 비용항목 불공제 세금코드가 다릅니다",
            "M_reMapSelectedPopupData_CHARGETOTAL_Common": "공급가액",
            "M_reMapSelectedPopupData_CHARGETOTAL_EVIKB_A": "공급가액/봉사료",
            "M_reMapSelectedPopupData_ISSUE_DATE_Common": "작성일자",
            "M_reMapSelectedPopupData_ISSUE_DATE_EVIKB_A": "일자",
            "M_reMapSelectedPopupData_ISSUE_ID_Common": "승인번호",
            "M_reMapSelectedPopupData_ISSUE_ID_EVIKB_A": "증빙번호",
            "M_reMapSelectedPopupData_SU_NAME_Common": "사업자명",
            "M_reMapSelectedPopupData_SU_NAME_EVIKB_A": "가맹점",
            "M_reMapSelectedPopupData_TYPE_CODE_TXT_EVIKB_A": "업종",
            "M_reMapSelectedPopupData_TYPE_CODE_TXT_EVIKB_B": "세금계산서 종류",
            "M_reMapSelectedPopupData_VAR_FIELD_1_EVIKB_A": "과세유형",
            "M_UD_0201_000_restoreStatementConfirm": "법인카드 삭제내역을 복구하시겠습니까?",
            "M_UD_0201_000_LIFNR_EMPTY": "등록된 거래처가 존재하지 않습니다",
            "M_UD_0201_010_assignPersonDialog": "담당자 지정 메모",
            "M_UD_0201_010_assignPersonCancelConfirm": "담당자 지정을 취소 하시겠습니까?",
            "M_UD_0201_010_deleteStatementDialog": "삭제사유",
            "M_UD_0201_010_canNotCreateStatementOfImportTaxInvoice": "수입 세금계산서는 자산전표 처리 불가합니다.",
            "M_UD_0201_010_canNotCreateStatementOfImportVATInvoice": "부가세 전표작성은 수입세금계산서만 처리 가능합니다.",
            "M_UD_0201_013_createStatementValidateRowSelect": "비용항목을 선택해주세요",
            "M_UD_0201_013_diffAmountNotZero": "선택한 비용항목의 합은 공급가액과 일치 해야합니다",
            "M_UD_0201_013_koreanCurrency": "원화",
            "M_UD_0201_013_gridDataNotExistsOnSelectedGridObj2": "구매전표번호와 조건유형에 맞는 항목이 존재하지 않습니다",
            "M_UD_0201_051_BELNR_EMPTY": "전표번호가 없는 건은 전기 할 수 없습니다",
            "M_UD_0201_052_DoSave_SubTotalGreaterThanZero": "소계 금액이 0보다 작거나 같은 경우만 저장 가능 합니다",
            "M_UD_0201_053_shouldInput1to31": "1~31 사이의 숫자만 입력 가능 합니다",
            "M_UD_0205_000_wrbtrBiggerThanAMT": "지급 금액이 잔액 보다 큽니다",
            "M_UD_0208_001_validateLIFNRSelect": "$name$ 을(를) 선택해주세요",
            "M_UD_0209_001_validateBeforeInsert": "차변 전기정보의 CO Object($kostlThTxt$, $aufnrThTxt$, $projkThTxt$)중 한개 이상 입력바랍니다",
            "M_UD_0220_002_search_business_trip_expenses_rules": "출장비 규정 조회",
            "M_UD_0220_002_outOfControlWhenPopupIsOpened": "정산화면 종료후 진행 바랍니다.",
            "M_UD_0302_000_groupSelectValidation": "[그룹 선택 실패]\n지정된 유형의 전표로만 함께 선택 가능 합니다\n",
            "M_UD_0302_000_validateFI_01_UNIQUE_LIFNR": "동일한 카드번호만 선택하세요",
            "M_UD_0302_000_cancelGroupConfirm": "선택된 데이터와 동일한 그룹번호가 모두 취소 됩니다\n취소 하시겠습니까?",
            "M_UD_0302_000_approvalPopupAccessError": "진행중인 [결재 상신, 결재문서 상세 조회] 건이 존재합니다\n진행중인 결재 프로세스 완료(팝업 종료) 후 처리 바랍니다",
            "M_UD_0302_000_cancelGroupGRONOEmpty": "그룹번호가 있는 항목만 취소 가능 합니다",
            "M_UD_0302_000_makeGroupGRONOExists": "그룹번호가 이미 존재 합니다",
            "M_UD_0302_000_makeGroupConfirm": "그룹번호를 생성 하시겠습니까?",
            "M_UD_0302_000_batchMakeGroupEmptyData": "그룹번호 생성할 데이터가 존재 하지 않습니다",
            "M_UD_0302_000_cannotControlApprovalScreenExist": "결재화면 종료후 진행 바랍니다.",
            "M_UD_0302_000_modifyStatementOnlyTempStatement": "전표상태가 [임시전표]인 경우에만 전표수정이 가능합니다.",
            "M_UD_0302_010_reprocessBSTAT_not_V_or_STATS_not_4": "결재 완료된 임시전표건만 처리 가능 합니다",
            "M_UD_0701_000_crerateStatementSelectedMoreThan1": "한건만 선택 할 수 있습니다",
            "M_UD_0701_000_crerateStatementSTATS_2": "해당 거래처는 결재중 상태이므로 생성이 불가합니다",
            "M_UD_0701_000_changeStatement_STATS_7_1_3": "해당 거래처는 결재미완료 상태이므로 변경이 불가합니다",
            "M_UD_0701_000_changeStatement_STATS_2": "해당 거래처는 결재중 상태이므로 변경이 불가합니다",
            "M_UD_0701_000_callApproval_STATS_2": "선택된 거래처에 결재중 상태인건이 존재하여 결재요청이 불가합니다",
            "M_UD_0701_020_reNewConfirm": "갱신진행하시겠습니까?",
            "M_UD_0702_000_ownerCanEdit": "작성자만 수정 가능합니다",
            "M_UD_0702_000_ownerCanDelete": "작성자만 삭제 가능합니다",
            "M_UD_0703_000_noticePrefix": "[공지] ",
            "M_UD_0204_001_evikb_only_set_z_when_paygb_b": "반환 전표인경우 증빙없음만 선택 가능합니다",
            "M_CardBill_Evidence inquiry": "증빙조회",
            "M_UD_0201_011_ZLSCH_ZFBDTNotExists" : "지급조건 필드가 존재하면 지급방법, 지급기산일 필드가 필수입니다.\n필드 추가바랍니다\n지급방법, 지급기산일 필드는 사용 하지 않을 경우\n필드 추가 후 APPEND에 체크바랍니다.",
            "M_addDataManage_click_grid1": "추가데이터 그룹 입력 후 선택하세요.",
            "M_addDataManage_addRowGrid2_validate1": "추가데이터 그룹 선택 후 행 추가하세요.",
            "M_addDataManage_addRowGrid2_validate2": "추가데이터 그룹 입력 후 행 추가하세요.",
            "M_addDataManage_saveGrid1_validate": "web data 저장 후 진행하세요.",
            "M_cannotSelectForEditWithGrono": "그룹번호가 생성되어 있어 전표 수정이 불가합니다.",
            "M_cannotSelectForEdit" : "[$programMenu$] 유형의 전표는 수정이 불가합니다.",
            "M_wbsIsEmpty": "등록된 WBS가 존재하지 않습니다.",
            "M_wrbtrIsEmpty": "공급가액을 입력해 주세요.",
            "M_wrbtrSplitSum_wrbtr_MISMATCH": "선택한 항목의 금액 합이 총금액과 일치하지 않습니다.",
            "M_wrbtrSplit_EMPTY": "금액 분할이 되지 않은 행이 포함되어 있습니다.",

            // DLT: Dialog Title
            "DLT_afterCreateStatementDialog": "전표생성",
            "DLT_afterModifyStatementDialog": "전표수정",
            "DLT_afterRequestDialogBusinessTripExpenses": "품의신청",
            "DLT_afterCreateStatementDialogBusinessTripExpenses": "품의정산",
            "DLT_approvalCommentsDialog_approvalComment": "승인 의견",
            "DLT_approvalCommentsDialog_arbitraryComment": "전결",
            "DLT_approvalCommentsDialog_cancelComment": "승인취소 의견",
            "DLT_approvalCommentsDialog_comment": "의견",
            "DLT_approvalCommentsDialog_rejectComment": "반려 의견",
            "DLT_approvalCommentsDialog_retrieveComment": "회수 의견",
            "DLT_batchApplyDialog": "일괄적용",
            "DLT_carBatchApplyDialog": "비용구분 일괄적용",
            "DLT_changeWF_ORGDialog": "참조기안 조회",
            "DLT_changeWF_ORGPalenTitle": "참조기안문서",
            "DLT_draftPreviewDialog": "품의서 미리보기",
            "DLT_modifyApprovalDialog_create": "기본결재선 생성",
            "DLT_modifyApprovalDialog_editDefault": "기본결재선 수정",
            "DLT_modifyApprovalDialog_edit": "결재선 수정",
            "DLT_MULTIPODATADialog": "구매전표번호 입력",
            "DLT_noticeDialog": "공지",
            "DLT_POHISTORYDialog": "구매오더 이력",
            "DLT_sendApprovalAlarmDialog": "결재문서 메일 보내기",
            "DLT_UD_0201_010_DIALOG": "매입세금계산서(전자)",
            "DLT_UD_0201_000_DIALOG": "법인카드 내역조회",
            "DLT_UD_0220_014_DIALOG": "품의선택",
            "DLT_ShowEvidence": "종이증빙 보기",
            "M_draft_0012_item1Empty": "예산 집행 현황을 입력해 주세요",
            "M_draft_0012_item2Empty": "추가 예산 신청을 입력해 주세요",
            "M_draft_0012_rowSelected": "예산 집행 현황을 선택하여 주십시오",
            "M_draft_0012_validateCHECK": "통제 대상이 아닙니다",
            "M_draft_0030_draft_0031_alreadyExists": "이미 추가된 출장자 입니다",
            "M_UD_0220_122_alreadyExistsCity": "출장자별 지역은 1곳만 선택 가능합니다.",

            // DLB: Dialog Button
            "DLB_send": "보내기",
            "DLB_queryStatement": "전표 조회",
            "DLB_createStatement": "전표작성",
            "DLB_requestApproval": "전자결재 작성",
            "DLB_evidenceRegistration": "증빙등록",
            "DLB_continueCreateStatement": "계속 작성"
        });
    }
});
